export enum VideoOutputType {
  TwoDimensional = '2D',
  AugmentedReality = 'AR'
}

export interface VideoFeature {
  name: string;
  url: string;
  size: number;
  isUploaded: boolean;
  type: string;
  file?: File;
  outputType: VideoOutputType;
} 